import { Component, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { environment } from 'src/environments/environment';
import { SettingService } from '../../services/setting.service';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ValidatorsService } from '../../services/validators.service';
import { TranslationService } from '../../services/translation.service';
import { LoaderService } from '../../services/loader.service';
import { Router } from '@angular/router';
import { AuthService, IEmailCodeResult } from 'src/app/auth/services/auth.service';
import { AnalyticsService } from '../../services/analytics.service';
import { finalize } from 'rxjs';
import { HttpErrorResponse } from '@angular/common/http';
import { HttpHelpers } from '../../helpers/http.helpers';
import { AlertService } from '../../services/alert.service';

export interface ILoginForm {
  email: string;
  password: string;
}

export interface IRegisterForm {
  email: string;
  codeId: number;
  codeExpirationTime: string;
  memberCard?: string;
}

export interface IForgotPasswordForm {
  email: string;
}

export interface INewPasswordForm {
  verificationCode: string;
  password: string;
  confirmPassword: string;
}

@Component({
  selector: 'app-login-landing-page',
  templateUrl: './login-landing-page.component.html',
  styleUrls: ['./login-landing-page.component.scss'],
  standalone: false
})
export class LoginLandingPageComponent  implements OnInit {
  // multi purpose page for login and landing page. (use this if you want to force user on a login page before accessing the homepage)
  
  
  
  // unsure what these are for normally from the "login.component"
  @Input() selfManage: boolean = false;
  @Input() fromDesktopCheckout: boolean = false;

  // registration
  alreadyInUse: boolean = false;
  EmailCodeId: number;
  EmailRegistration: string;

  registrationStep: number = 1;

  // forgoten password
  emailCode: IEmailCodeResult;
  forgotPasswordForm: IForgotPasswordForm;


  loginForm: FormGroup;
  registerForm: FormGroup;
  registerConfirmationForm: FormGroup;
  forgotPassForm: FormGroup;
  passChangeForm: FormGroup;
  formErrors: Map<string, string> = new Map<string, string>();

  patternReference: any = {};


  logoShifted: boolean = false;


  windowCredential: string = "signin";

  get icon() {
    const geodataStr  = localStorage.getItem('savedGeoLocation');
    const geodata = geodataStr ? JSON.parse(geodataStr) : null;
    

    if (environment.deviceApp)
      return '/assets/logo.png';

    if(this.settingService.configuration.useAlternatLogoIcon && !this.settingService.configuration.alternateLogoIcon?.useDefaultIcon) {
      var condition = "";
      var matchCondition = false;
      if( this.settingService.configuration.alternateLogoIcon?.showCondition?.showByStatesProvince) {
        condition = this.settingService.configuration.alternateLogoIcon?.showCondition?.stateOrProvince;
        if(condition == "QC") {
          condition = "Québec"; // need to do this to match the value from the API
        }


        if(geodata.state == condition) {
          matchCondition = true;
        }
      }


      if (!this.settingService.alticon || !matchCondition){
        if (!this.settingService.icon){
          return this.logo;
        }
          
          
        return this.settingService.icon;
      }
        
      return this.settingService.alticon;
    } else {
      if (!this.settingService.icon){
        return this.logo;
      }
        
        
      return this.settingService.icon;
    }
    
  }

  get logo() {
    const geodataStr  = localStorage.getItem('savedGeoLocation');
    const geodata = geodataStr ? JSON.parse(geodataStr) : null;

    if (environment.deviceApp)
      return '/assets/logo.png';

    if(this.settingService.configuration.useAlternatLogoIcon && !this.settingService.configuration.alternateLogoIcon?.useDefaultLogo) {
      var condition = "";
      var matchCondition = false;
      if( this.settingService.configuration.alternateLogoIcon?.showCondition?.showByStatesProvince) {
        condition = this.settingService.configuration.alternateLogoIcon?.showCondition?.stateOrProvince;
        if(condition == "QC") {
          condition = "Québec"; // need to do this to match the value from the API
        }


        if(geodata.state == condition) {
          matchCondition = true;
        }
      }
      

      if(this.settingService.altlogo && matchCondition) {
        return this.settingService.altlogo
      } else {
        return this.settingService.logo;
      }
    } else {
      return this.settingService.logo;
    }
    
  }

  get emailPlaceHolder(): string {
    return this.translationService.translate('Auth.Email');
  }

  get passwordPlaceHolder(): string {
    return this.translationService.translate('Auth.Password');
  }

  get verificationCodePlaceHolder(): string {
    return this.translationService.translate('Auth.VerificationCode');
  }

  get confirmPasswordPlaceHolder(): string {
    return this.translationService.translate('Auth.ConfirmPassword');
  }

  constructor(
    private modalCtrl: ModalController,
    public settingService: SettingService,
    private fb: FormBuilder,
    //private translate: TranslateService,
    public validators: ValidatorsService,
    private translationService: TranslationService,
    private loader: LoaderService,
    private router: Router,
    private authService: AuthService,
    private analytics: AnalyticsService,
    private alert: AlertService
  ) { }

  ngOnInit() {

    this.loginForm = this.fb.group({
      email: this.fb.control('', {
        validators: this.validators.formBuilderValidationInitializer(true, null, true),
        updateOn: 'change'
      }),
      password: this.fb.control('', {
        validators: this.validators.formBuilderValidationInitializer(true),
        updateOn: 'change'
      })
    });

    this.registerForm = this.fb.group({
      email: this.fb.control('', {
        validators: this.validators.formBuilderValidationInitializer(true, null, true),
        updateOn: 'change'
      })
    });


    this.registerConfirmationForm = this.fb.group({

      randomCode: this.fb.control('', {
        validators: this.validators.formBuilderValidationInitializer(true, null, null)
      }),

      firstName: this.fb.control('', {
        validators: this.validators.formBuilderValidationInitializer(true, null, null)
      }),

      lastName: this.fb.control('', {
        validators: this.validators.formBuilderValidationInitializer(true, null, null)
      }),

      password: this.fb.control('', {
        validators: this.validators.formBuilderValidationInitializer(true, null, null)
      }),

      confirmPassword: this.fb.control('', {
        validators: this.validators.formBuilderValidationInitializer(true, null, null)
      }),

      acceptEmails: this.fb.control(true)  // no validators
    });


    this.forgotPassForm = this.fb.group({
      email: this.fb.control('', {
        validators: this.validators.formBuilderValidationInitializer(true, null, true),
        updateOn: 'change'
      })
    });

    this.passChangeForm = this.fb.group({
      verificationCode: this.fb.control('', {
        validators: this.validators.formBuilderValidationInitializer(true, null, null),
        updateOn: 'change'
      }),
      password: this.fb.control('', {
        validators: this.validators.formBuilderValidationInitializer(true, null, null),
        updateOn: 'change'
      }),
      confirmPassword: this.fb.control('', {
        validators: this.validators.formBuilderValidationInitializer(true, null, null),
        updateOn: 'change'
      })
    });


    /*
    this.patternReference = {
      email: null
    };

    //this.validators.trackInputChange(this.form);
    this.validators.trackInputChange(this.form, this.patternReference);
    */

    
    const interval = setInterval(() => {
      if (this.settingService.logoReady &&
          this.settingService.iconReady &&
          this.settingService.altlogoReady &&
          this.settingService.alticonReady) {
        clearInterval(interval);
        setTimeout(() => {
          this.logoShifted = true;
        }, 2500);
      }
    }, 100); // check every 100ms

    /*
    setTimeout(() => {
      this.logoShifted = true;
    }, 2500);
    */
  }

  async loginformSubmitted() {

    //sanitizing
    this.loginForm.setValue(this.validators.multiSanitizerInput(this.loginForm.value));

    if (!this.loginForm.valid)
            return;

    this.formErrors.clear();

    const loader = await this.loader.create();
    this.authService.login({
      Email: this.loginForm.get("email").value,
      Password: this.loginForm.get("password").value
    })
    .pipe(finalize(async () => {
      await loader.dismiss();
    }))
    .subscribe((result) => {
      //this.onLogin.emit(); // this dismisses the popup normally. instead of this, we'll actually move to /home

      if (this.selfManage || this.fromDesktopCheckout) {
        return;
      }

      this.analytics.conversionUpdate("signIn");

      
      // this will change too. we'll simply go to "/home" for now
      /*
      var CurrentUrl;
      CurrentUrl = localStorage.getItem('Stateurl');
      this.router.navigateByUrl(CurrentUrl);
      */
      this.router.navigateByUrl('/home');
    }, (error) => {
      this.authService.showLoginError(error);
    });
  }

  async registrationformSubmitted() {
    //sanitizing
    this.registerForm.setValue(this.validators.multiSanitizerInput(this.registerForm.value));

    this.alreadyInUse = false;

    if (!this.registerForm.valid)
      return;

    this.formErrors.clear();

    // put the logic for the member card here before we send the code
    if(this.settingService.configuration.memberCardMandatory) {
      //this.OpenMemberCardModal();

    } else {

      const loader = await this.loader.create();
      await loader.present();
      this.authService.emailCodeVerificationStart(this.registerForm.get("email").value, "Register", this.translationService.getLanguage())
        .pipe(finalize(() => {
          loader.dismiss();
        }))
        .subscribe(result => {

          console.log(result);
          /*
          this.onSubmit.emit({
            email: this.registerForm.get("email").value,
            codeId: result.EmailCodeId,
            codeExpirationTime: result.ExpirationTime,
          });
          */
          this.EmailCodeId = result.EmailCodeId;
          this.EmailRegistration = this.registerForm.get("email").value;
          this.registrationStep = 2;


          
        },
        (error: HttpErrorResponse) => {
          if (error.error.Message == 'AlreadyExist')
            this.alreadyInUse = true;
        });
    }
  }


  // registration confirmation process
  /*
  async OpenMemberCardModal() {
    // prevents crash if the undocked navbar is inside a popup
    const modal = await this.modalCtrl.create({
      component: CardNumberModalComponent,
      cssClass: '',
      componentProps: {
        disableHeader: true
      }
    });
  
    modal.onWillDismiss()
      .then(async (modalResult) => {

        if(modalResult.data != null) {
          const loader = await this.loader.create();
          await loader.present();
          this.auth.emailCodeVerificationStart(this.form.get("email").value, "Register", this.translationService.getLanguage())
            .pipe(finalize(() => {
              loader.dismiss();
            }))
            .subscribe(result => {
              this.onSubmit.emit({
                email: this.form.get("email").value,
                codeId: result.EmailCodeId,
                codeExpirationTime: result.ExpirationTime,
                memberCard: modalResult.data
              });
            },
            (error: HttpErrorResponse) => {
              if (error.error.Message == 'AlreadyExist')
                this.alreadyInUse = true;
            });
        }
        
    });
  
    await modal.present();
  }
    */

  async registrationConfirmationformSubmitted() {
    //sanitizing
    this.registerConfirmationForm.setValue(this.validators.multiSanitizerInput(this.registerConfirmationForm.value));

    if (!this.registerConfirmationForm.valid)
      return;

    this.formErrors.clear();

    const loader = await this.loader.create();
    await loader.present();
    this.authService.register({
      AcceptEmails: this.registerConfirmationForm.get('acceptEmails').value,
      Id: this.EmailCodeId,
      Password: this.registerConfirmationForm.get('password').value,
      ConfirmPassword: this.registerConfirmationForm.get('confirmPassword').value,
      FirstName: this.registerConfirmationForm.get('firstName').value,
      LastName: this.registerConfirmationForm.get('lastName').value,
      RandomCode: this.registerConfirmationForm.get('randomCode').value,
    })
      .pipe(finalize(() => {
        loader.dismiss();
      }))
      .subscribe(result => {

        /*
        ////////////////////////////////////////////
        // this only happens if there's a member card added during registration
        if(this._emailCode.memberCard != null) {
          this.account.addExistingCard(this._emailCode.memberCard)
            .subscribe((model) => {

            });
        }
        ////////////////////////////////////////////
        */

        //this.onSubmit.emit();
        this.analytics.conversionUpdate("signUp");

        this.onRegistrationCompleted();
      },
      (error: HttpErrorResponse) => {
        if (error.status == 500)
          this.alert.showUnexpectedErrorMsg();
        else {
          const modelState = error.error.ModelState;

          if (!modelState) 
            return;

          for (let key in modelState) {
            let property = HttpHelpers.removePrefix(key, 'model.');
            property = property.charAt(0).toLowerCase() + property.slice(1);
            this.formErrors.set(property, modelState[key][0]);
          }
        }
      });

  }

  async onRegistrationCompleted() {
    /*
    if(this.fromDesktopCheckout){
      const loader = await this.loader.create();
      await loader.present();
      this.accountService.generate()
        .pipe(finalize(async () => {
          await loader.dismiss();
        }))
        .subscribe(() => {
          this.modalCtrl.dismiss({
            onLogin: true
          });
        });
      return false;
    } else {
      this.router.navigateByUrl('/home');
      //this.router.navigateByUrl('/account/profile');
      //this.step = 'completed';
    }
    */

    this.router.navigateByUrl('/home');
  }

  async forgotPassformSubmitted() {
    //sanitizing
    this.forgotPassForm.setValue(this.validators.multiSanitizerInput(this.forgotPassForm.value));

    if (!this.forgotPassForm.valid)
            return;

    this.formErrors.clear();

    /*
    this.onSubmit.emit({
      email: this.form.get("email").value
    });
    */

    const loader = await this.loader.create();
    await loader.present();
    this.authService.emailCodeVerificationStart(this.forgotPassForm.get('email').value, "ForgotPassword", this.translationService.getLanguage())
      .pipe(finalize(() => {
        loader.dismiss();
      }))
      .subscribe((result) => {
        this.forgotPasswordForm = {
          email: this.forgotPassForm.get("email").value
        };
        this.emailCode = result;
      },
      (res: HttpErrorResponse) => {
        if (res.status == 404) {
          this.alert.showTranslate('FPW.NOT_PART_OF_LISTING_MSG');
        }
      });
  }

  async onPassChangeformSubmitted() {
    //sanitizing
    this.passChangeForm.setValue(this.validators.multiSanitizerInput(this.passChangeForm.value));

    if (!this.passChangeForm.valid)
      return;

    this.formErrors.clear();

    /*
    this.onSubmit.emit({
      verificationCode: this.form.get("verificationCode").value,
      password: this.form.get("password").value,
      confirmPassword: this.form.get("confirmPassword").value,
    });
    */

    const loader = await this.loader.create();
    await loader.present();
    this.authService.forgotPassword({
      Id: this.emailCode.EmailCodeId,
      RandomCode: this.passChangeForm.get("verificationCode").value,
      NewPassword: this.passChangeForm.get("password").value,
      NewPasswordConfirmation: this.passChangeForm.get("confirmPassword").value
    })
      .pipe(finalize(() => {
        loader.dismiss();
      }))
      .subscribe((result) => {
        this.notReceivedAnyCode();
      }/*, (error: HttpErrorResponse) => {
        if (error.status == 500)
          this.alertService.showUnexpectedErrorMsg();
        else {
          const modelState = error.error.ModelState;

          if (!modelState) 
            return;

          for (let key in modelState) {
            let property = HttpHelpers.removePrefix(key, 'model.');
            property = property.charAt(0).toLowerCase() + property.slice(1);
            this.formErrors.set(property, modelState[key][0]);
            console.log(this.formErrors);
          }
        }
      }*/);

  }

  notReceivedAnyCode() {
    this.forgotPasswordForm = null;
    this.emailCode = null;
  }

  changeAuth(authWindow: string) {
    this.windowCredential = authWindow;
  }

}
